import { BlockDefinition } from '../../../types/pageBuilder';

// Ícones SVG bonitos para cada tipo de bloco
const icons = {
  heroCentered: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="7" y1="8" x2="17" y2="8"/>
    <line x1="9" y1="12" x2="15" y2="12"/>
    <rect x="9" y="15" width="6" height="2" rx="1" fill="currentColor"/>
  </svg>`,
  heroSplit: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="7" x2="10" y2="7"/>
    <line x1="5" y1="10" x2="9" y2="10"/>
    <rect x="5" y="13" width="4" height="2" rx="1" fill="currentColor"/>
    <rect x="14" y="7" width="6" height="8" rx="1"/>
  </svg>`,
  heroVideo: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="12" cy="14" r="4"/>
    <polygon points="11,12.5 11,15.5 14,14" fill="currentColor"/>
    <line x1="8" y1="6" x2="16" y2="6"/>
  </svg>`,
  heroDark: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" opacity="0.2"/>
    <line x1="7" y1="8" x2="17" y2="8"/>
    <line x1="9" y1="12" x2="15" y2="12"/>
    <rect x="9" y="15" width="6" height="2" rx="1"/>
    <circle cx="18" cy="6" r="2" fill="currentColor"/>
  </svg>`,
  heroMinimal: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <line x1="8" y1="10" x2="16" y2="10"/>
    <line x1="10" y1="14" x2="14" y2="14"/>
  </svg>`
};

export const heroBlocks: BlockDefinition[] = [
  {
    id: 'hero-centered',
    label: 'Hero Centralizado',
    category: 'Seções Hero',
    media: icons.heroCentered,
    content: `
      <section class="hero-section" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 120px 20px; text-align: center;">
        <div style="max-width: 900px; margin: 0 auto;">
          <h1 style="font-size: 3.5rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.1;">
            Transforme Seus Resultados com Nossa Solução
          </h1>
          <p style="font-size: 1.25rem; color: rgba(255,255,255,0.9); margin-bottom: 40px; line-height: 1.6;">
            A plataforma mais completa para impulsionar seus resultados e alcançar o sucesso que você merece.
          </p>
          <div style="display: flex; gap: 16px; justify-content: center; flex-wrap: wrap;">
            <a href="#" style="display: inline-block; padding: 16px 32px; background-color: white; color: #667eea; font-weight: 600; font-size: 1rem; border-radius: 8px; text-decoration: none; transition: transform 0.2s;">
              Começar Agora
            </a>
            <a href="#" style="display: inline-block; padding: 16px 32px; background-color: transparent; color: white; font-weight: 600; font-size: 1rem; border: 2px solid rgba(255,255,255,0.5); border-radius: 8px; text-decoration: none;">
              Saiba Mais
            </a>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-hero' }
  },
  {
    id: 'hero-split',
    label: 'Hero Dividido',
    category: 'Seções Hero',
    media: icons.heroSplit,
    content: `
      <section class="hero-split" style="padding: 80px 20px; background-color: #ffffff;">
        <div style="max-width: 1200px; margin: 0 auto; display: flex; align-items: center; gap: 60px; flex-wrap: wrap;">
          <div style="flex: 1; min-width: 300px;">
            <span style="display: inline-block; padding: 8px 16px; background-color: #eef2ff; color: #4f46e5; font-size: 0.875rem; font-weight: 600; border-radius: 9999px; margin-bottom: 20px;">
              Novidade
            </span>
            <h1 style="font-size: 3rem; font-weight: 800; color: #111827; margin-bottom: 24px; line-height: 1.1;">
              Leve seu negócio para o próximo nível
            </h1>
            <p style="font-size: 1.125rem; color: #6b7280; margin-bottom: 32px; line-height: 1.7;">
              Descubra como nossa solução pode ajudar sua empresa a crescer de forma sustentável e escalável.
            </p>
            <div style="display: flex; gap: 16px; flex-wrap: wrap;">
              <a href="#" style="display: inline-block; padding: 14px 28px; background-color: #4f46e5; color: white; font-weight: 600; border-radius: 8px; text-decoration: none;">
                Começar Grátis
              </a>
              <a href="#" style="display: inline-flex; align-items: center; gap: 8px; padding: 14px 28px; color: #4f46e5; font-weight: 600; text-decoration: none;">
                <span>Ver Demonstração</span>
                <svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
                  <path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </a>
            </div>
          </div>
          <div style="flex: 1; min-width: 300px;">
            <img src="https://placehold.co/600x450/e0e7ff/4f46e5?text=Sua+Imagem" alt="Imagem Hero" style="width: 100%; border-radius: 16px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.1);">
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-hero' }
  },
  {
    id: 'hero-video',
    label: 'Hero com Vídeo',
    category: 'Seções Hero',
    media: icons.heroVideo,
    content: `
      <section class="hero-video" style="background-color: #0f172a; padding: 100px 20px; text-align: center;">
        <div style="max-width: 1000px; margin: 0 auto;">
          <h1 style="font-size: 3rem; font-weight: 800; color: white; margin-bottom: 20px;">
            Veja como funciona na prática
          </h1>
          <p style="font-size: 1.125rem; color: #94a3b8; margin-bottom: 40px;">
            Assista o vídeo e descubra como podemos transformar seu negócio
          </p>
          <div style="position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; border-radius: 16px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5);">
            <iframe
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ"
              title="Vídeo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen>
            </iframe>
          </div>
          <div style="margin-top: 40px;">
            <a href="#" style="display: inline-block; padding: 16px 32px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; font-weight: 600; border-radius: 8px; text-decoration: none;">
              Quero Começar Agora
            </a>
          </div>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-hero' }
  },
  {
    id: 'hero-gradient-dark',
    label: 'Hero Gradiente Escuro',
    category: 'Seções Hero',
    media: icons.heroDark,
    content: `
      <section class="hero-dark" style="background: linear-gradient(180deg, #1e1b4b 0%, #312e81 50%, #4c1d95 100%); padding: 120px 20px; text-align: center; position: relative; overflow: hidden;">
        <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><circle fill=\"rgba(255,255,255,0.05)\" cx=\"16\" cy=\"16\" r=\"1\"/></svg>') repeat; background-size: 32px 32px;"></div>
        <div style="position: relative; max-width: 800px; margin: 0 auto;">
          <div style="display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255,255,255,0.1); border-radius: 9999px; margin-bottom: 24px;">
            <span style="width: 8px; height: 8px; background-color: #34d399; border-radius: 50%;"></span>
            <span style="color: #a5b4fc; font-size: 0.875rem;">Novo lançamento 2025</span>
          </div>
          <h1 style="font-size: 4rem; font-weight: 800; color: white; margin-bottom: 24px; line-height: 1.05;">
            O futuro do marketing digital começa aqui
          </h1>
          <p style="font-size: 1.25rem; color: #c7d2fe; margin-bottom: 40px; line-height: 1.6;">
            Automatize, otimize e escale suas campanhas com inteligência artificial de ponta.
          </p>
          <div style="display: flex; gap: 16px; justify-content: center;">
            <a href="#" style="display: inline-block; padding: 18px 36px; background: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%); color: white; font-weight: 600; font-size: 1rem; border-radius: 12px; text-decoration: none; box-shadow: 0 10px 40px -10px rgba(139, 92, 246, 0.5);">
              Começar Gratuitamente
            </a>
          </div>
          <p style="margin-top: 20px; color: #a5b4fc; font-size: 0.875rem;">
            Sem cartão de crédito. Cancele quando quiser.
          </p>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-hero' }
  },
  {
    id: 'hero-minimal',
    label: 'Hero Minimalista',
    category: 'Seções Hero',
    media: icons.heroMinimal,
    content: `
      <section class="hero-minimal" style="padding: 160px 20px; background-color: #fafafa;">
        <div style="max-width: 700px; margin: 0 auto; text-align: center;">
          <h1 style="font-size: 4rem; font-weight: 700; color: #111827; margin-bottom: 24px; line-height: 1;">
            Simplicidade que converte.
          </h1>
          <p style="font-size: 1.25rem; color: #6b7280; margin-bottom: 48px;">
            Menos distração. Mais resultado.
          </p>
          <a href="#" style="display: inline-block; padding: 16px 40px; background-color: #111827; color: white; font-weight: 500; border-radius: 4px; text-decoration: none; letter-spacing: 0.05em; text-transform: uppercase; font-size: 0.875rem;">
            Começar
          </a>
        </div>
      </section>
    `,
    attributes: { class: 'gjs-block-hero' }
  }
];
